export default __webpack_public_path__ + "static/media/bitcoin-card.5bdaf6dd.png";